<script lang="ts" setup>
  // TODO-DS: Remove after migration to QIC Connect DS.
  import WhatsAppIcon from '@/shared/components/icons/WhatsAppIcon.vue'
  import { WHATSAPP_URL } from './WhatsAppButton.constants'

  interface Props {
    href: string
    dataTest?: string
  }
  interface Emits {
    (e: 'onClick'): void
  }
  withDefaults(defineProps<Props>(), {
    href: WHATSAPP_URL,
    dataTest: 'whatsapp-button',
  })
  const emit = defineEmits<Emits>()
</script>

<template>
  <a
    :href="href"
    class="whatsapp-button"
    target="_blank nofollow noopener"
    :data-test="dataTest"
    @click="emit('onClick')"
  >
    <WhatsAppIcon />
    <slot>{{ $t('contact_us_popup.whatsapp.button') }}</slot>
  </a>
</template>

<style lang="scss" scoped>
  @import './WhatsAppButton';
</style>
